<profile-editor>
  <div class="profile-editor">
    <!-- Page Header -->
    <page-header
      title="Mi Perfil"
      subtitle="Actualiza tu información personal y credenciales"
      onback={ handleGoToDevices }>
    </page-header>

    <!-- Mensaje de éxito -->
    <div if={ state.successMessage } class="alert alert-success alert-dismissible fade show" role="alert">
      <i class="bi bi-check-circle-fill me-2"></i>
      { state.successMessage }
      <button type="button" class="btn-close" onclick={ clearMessages }></button>
    </div>

    <!-- Mensaje de error -->
    <error-alert
      if={ state.errorMessage }
      message={ state.errorMessage }
      ondismiss={ clearMessages } />

    <!-- Formulario -->
    <form id="profileForm" onsubmit={ handleSubmit } novalidate>

      <!-- Card: Datos personales -->
      <div class="card mb-4">
        <div class="card-header d-flex align-items-center gap-2">
          <i class="bi bi-person-circle text-primary"></i>
          <h5 class="mb-0">Datos personales</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3 mb-md-0">
                <label for="username" class="form-label">Nombre de usuario <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-person"></i></span>
                  <input type="text" class="form-control { state.errors['username'] ? 'is-invalid' : '' }" id="username" name="username" value={ state.username } oninput={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['username'] }>{ state.errors['username'] }</div>
                </div>
                <div class="form-text">Tu nombre visible dentro de la plataforma</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-0">
                <label for="email" class="form-label">Correo electrónico <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                  <input type="email" class="form-control { state.errors['email'] ? 'is-invalid' : '' }" id="email" name="email" value={ state.email } oninput={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['email'] }>{ state.errors['email'] }</div>
                </div>
                <div class="form-text">Lo usás para iniciar sesión</div>
              </div>
            </div>
          </div>

          <div class="row mt-3" if={ isAdmin() }>
            <div class="col-md-6">
              <div class="mb-0">
                <label for="role" class="form-label">Rol</label>
                <select class="form-select" id="role" name="role" value={ state.role } onchange={ handleInputChange }>
                  <option value="user">Usuario</option>
                  <option value="admin">Administrador</option>
                </select>
                <div class="form-text">Determina tus permisos en la plataforma</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card: Seguridad / contraseña -->
      <div class="card mb-4">
        <div class="card-header d-flex align-items-center gap-2">
          <i class="bi bi-shield-lock text-primary"></i>
          <h5 class="mb-0">Cambiar contraseña</h5>
        </div>
        <div class="card-body">
          <div class="alert alert-info d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-info-circle"></i>
            <span>Dejá estos campos vacíos si no querés cambiar tu contraseña.</span>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="mb-3 mb-md-0">
                <label for="currentPassword" class="form-label">Contraseña actual</label>
                <input type="password" class="form-control { state.errors['currentPassword'] ? 'is-invalid' : '' }" id="currentPassword" name="currentPassword" value={ state.currentPassword } oninput={ handleInputChange } autocomplete="current-password">
                <div class="invalid-feedback" if={ state.errors['currentPassword'] }>{ state.errors['currentPassword'] }</div>
                <div class="form-text">Requerida para confirmar el cambio</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3 mb-md-0">
                <label for="newPassword" class="form-label">Nueva contraseña</label>
                <input type="password" class="form-control { state.errors['newPassword'] ? 'is-invalid' : '' }" id="newPassword" name="newPassword" value={ state.newPassword } oninput={ handleInputChange } autocomplete="new-password">
                <div class="invalid-feedback" if={ state.errors['newPassword'] }>{ state.errors['newPassword'] }</div>
                <div class="form-text">Mínimo 6 caracteres</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-0">
                <label for="confirmPassword" class="form-label">Confirmar nueva contraseña</label>
                <input type="password" class="form-control { state.errors['confirmPassword'] ? 'is-invalid' : '' }" id="confirmPassword" name="confirmPassword" value={ state.confirmPassword } oninput={ handleInputChange } autocomplete="new-password">
                <div class="invalid-feedback" if={ state.errors['confirmPassword'] }>{ state.errors['confirmPassword'] }</div>
                <div class="form-text">Debe coincidir con la nueva</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-secondary app-btn app-btn-md" onclick={ handleGoToDevices }>
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary app-btn app-btn-md">
              <i class="bi bi-save me-1"></i> Guardar cambios
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <script>
    import PageHeader from './page-header.riot';
    import ErrorAlert from './error-alert.riot';
    import { AuthService } from '../services/api-service';
    import { ToastService } from '../services/toast-service';

    export default {
      components: {
        PageHeader,
        ErrorAlert
      },
      state: {
        username: '',
        email: '',
        role: 'user',
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        successMessage: '',
        errorMessage: '',
        errors: {}
      },

      onMounted() {
        this.loadUserData();
      },

      isAdmin() {
        return AuthService.isAdmin();
      },

      handleInputChange(e) {
        const { name, value } = e.target;
        this.update({
          errors: this.clearError(name),
          [name]: value
        });
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors;
        }

        const errors = { ...this.state.errors };
        delete errors[name];
        return errors;
      },

      validateForm() {
        const { username, email, currentPassword, newPassword, confirmPassword } = this.state;
        const errors = {};

        if (!username.trim()) {
          errors.username = 'El nombre de usuario es requerido';
        }

        if (!email.trim()) {
          errors.email = 'El correo electrónico es requerido';
        } else {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(email)) {
            errors.email = 'El formato del correo electrónico no es válido';
          }
        }

        // Contraseña: opcional, pero si se cambia debe cumplir las reglas
        if (newPassword && newPassword.length < 6) {
          errors.newPassword = 'La nueva contraseña debe tener al menos 6 caracteres';
        }

        if (newPassword && newPassword !== confirmPassword) {
          errors.confirmPassword = 'Las contraseñas no coinciden';
        }

        if (newPassword && !currentPassword) {
          errors.currentPassword = 'Debes proporcionar tu contraseña actual para cambiarla';
        }

        this.update({ errors });

        if (Object.keys(errors).length > 0) {
          ToastService.error('Revisá los campos marcados en rojo');
          return false;
        }

        return true;
      },

      async loadUserData() {
        const userData = await AuthService.getCurrentUser();
        if (userData) {
          this.update({
            username: userData.username || '',
            email: userData.email || '',
            role: userData.roles && userData.roles.length > 0 ? userData.roles[0] : 'user'
          });
        }
      },

      handleGoToDevices() {
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
      },

      clearMessages() {
        this.update({
          successMessage: '',
          errorMessage: ''
        });
      },

      async handleSubmit(e) {
        e.preventDefault();

        if (!this.validateForm()) {
          return;
        }

        const { username, email, role, currentPassword, newPassword } = this.state;

        const updateData = {
          username,
          email,
          currentPassword: currentPassword || undefined,
          newPassword: newPassword || undefined,
          role: this.isAdmin() ? role : undefined
        };

        try {
          await AuthService.updateProfile(updateData);
          this.update({
            successMessage: 'Perfil actualizado correctamente',
            errorMessage: ''
          });
          ToastService.success('Perfil actualizado correctamente');
          if (this.props.onupdate) {
            this.props.onupdate();
          }
        } catch (error) {
          const errorMsg = error instanceof Error ? error.message : 'Error al actualizar el perfil';
          this.update({
            successMessage: '',
            errorMessage: errorMsg
          });
          ToastService.error(errorMsg);
        }
      }
    }
  </script>
</profile-editor>
